const PaidInclusionReleaseDate = ({
    faqUrl = '',
    releaseText = '',
    releaseDate = '',
    releaseDateTimestamp = null,
    state = '',
}) => ({
    faqUrl: String(faqUrl),
    releaseText: String(releaseText),
    releaseDate: String(releaseDate),
    releaseDateTimestamp: Number(releaseDateTimestamp),
    state: String(state),
});

export default PaidInclusionReleaseDate;
